import React, { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import apiClient from "../services/apiClient"
import { getAccessToken, setAccessToken, setAccountTokens } from "../services/apiClient"
import AdminLayout from "../layouts/AdminLayout"

interface AuthGuardProps {
  children: React.ReactNode
}

const AuthGuard: React.FC<AuthGuardProps> = ({ children }) => {
  const navigate = useNavigate()
  const [ready, setReady] = useState(false)

  useEffect(() => {
    // Token already in memory (navigation between pages) — skip refresh
    if (getAccessToken()) {
      setReady(true)
      return
    }

    // Token missing (page reload) — restore session via refresh cookie
    apiClient
      .post("/auth/refresh", undefined, { withCredentials: true })
      .then((res) => {
        const data = res.data?.data || {}
        setAccessToken(data.authToken)
        if (data.accounts?.length) setAccountTokens(data.accounts)
        setReady(true)
      })
      .catch(() => {
        navigate("/login")
      })
  }, [navigate])

  if (!ready) return null

  return <AdminLayout>{children}</AdminLayout>
}

export default AuthGuard
